import request from '../request'

export async function IsLogin(options:any){
    return request('api/User/Login',{
        method:"POST",
        ...(options || {})
    })
}
export async function CreateUser(options:any){
    return request('api/User/CreateUser',{
        method:"POST",
        ...(options || {})
    })
}
export async function EditUsers(options:any){
    return request('api/User/EditUser',{
        method:"POST",
        ...(options || {})
    })
}
export async function GetUserList(options?:any){
    return request('api/User/GetList',{
        method:"GET",
        ...(options || {})
    })
}
export async function GetUserDetail(options?:any){
    return request('api/User/GetDetail',{
        method:"GET",
        ...(options || {})
    })
}